/**
 * Responsive panel widths for `FolioDrawer`'s `size` prop.
 * `wide` suits forms and editors; `narrow` suits contact, filter and preview panels.
 */
export const DRAWER_WIDTHS = {
	wide: {
		xs: '100vw',
		sm: '90vw',
		md: '78vw',
		lg: '72vw',
		xl: '68vw',
	},
	narrow: {
		xs: '100vw',
		sm: 560,
	},
};

/**
 * Panel widths for `FolioDrawer`'s `maximisedSize` prop when the maximise toggle is on.
 * `reduced` leaves part of the page visible and is never narrower than `DRAWER_WIDTHS.wide`;
 * `full` covers the whole viewport, for the Unlayer editors.
 */
export const DRAWER_MAXIMISED_WIDTHS = {
	reduced: {
		xs: '100vw',
		sm: '90vw',
		md: '80vw',
	},
	full: '100vw',
};

/**
 * Slide durations in ms for `FolioDrawer`. Closing is slower than MUI's 195ms default
 * so the drawer doesn't vanish abruptly.
 */
export const DRAWER_TRANSITION = {
	enter: 225,
	exit: 300,
};
